import { BootResourceName } from '../resources';
import { getTimingData } from './getTimingData';

/**
 * Returns the load time and size information for static resource required during
 * the bootstrap.
 * Includes —
 * 1. Shared bootstrap bundle
 * 2. Mini and framework vendor bundles
 * 2. Common JS bundle
 * @returns
 */
export const getBootStaticResourcePerformanceTiming = () => {
    const performanceTimingResult = {};
    [
        BootResourceName.SharedBoot,
        BootResourceName.MiniVendors,
        BootResourceName.FrameVendors,
        BootResourceName.MiniCommon,
    ].forEach(resource => {
        const timingData = getTimingData(resource, true /** include size info  */);
        if (timingData) {
            performanceTimingResult[resource] = timingData;
        }
    });

    return performanceTimingResult;
};
